<!--
// app/components/Shared/news/ByExternalMedia.vue
-->
<script setup lang="ts">
type Props = {
  logo_url: string;
};

defineProps<Props>();
</script>

<template>
  <div
    class="rounded-sm bg-black bg-opacity-60 flex items center max-w-min gap-x-1 px-1 py-0.5 opacity-95 mb-1"
  >
    <span class="text-[0.5rem]">BY</span>
    <div class="min-w-[35px]">
      <img :src="logo_url" class="block w-[35px] h-auto" alt="External media logo" />
    </div>
  </div>
</template>

<style scoped></style>
